<template>
    <div class="aba-produto">
        <div class="vertical-flow">
            <div class="columns">
                <div class="column">
                    <search-bar
                        :onSearch="debouncedOnSearch"
                        tooltipLabel="msg-campo-busca-pacotekit-produto"
                    />
                </div>
                <div class="column" :class="[permissao.create && !integracao ? 'is-2' : 'is-3']">
                    <vss-select
                        ref="situacaoSelect"
                        :searchable="false"
                        :options="situacaoSelect"
                        v-model="situacaoSelected"
                        mlLabels
                        title="situacao"
                        clearable
                        @input="onSituacaoChanged"
                        :height="40"
                    />
                </div>
                <div class="column is-3" v-if="permissao.create && !integracao">
                    <button
                        class="save-btn botao-acao"
                        type="button"
                        @click="showModalVincularProduto"
                    >
                        {{ $t('vincular-produto') }}
                    </button>
                </div>
                <div class="column is-3" v-if="permissaoPacote.create && !ProdutoIntegracao">
                    <button
                        class="save-btn botao-acao"
                        type="button"
                        @click="
                            $router.push({
                                name: 'ven-produto-new',
                                query: { tela: 'ven-pacote-kit', id: $route.params.id },
                            })
                        "
                    >
                        {{ $t('adicionar-produto') }}
                    </button>
                </div>
            </div>
            <div class="registry-wrapper">
                <container-loader v-if="isLoading && !$store.getters.isLoading" />
                <empty-table-message v-if="isEmpty" />
                <b-table
                    v-else
                    :data="assprodutoProduto"
                    class="data-table"
                    @sort="sortTable"
                    backend-sorting
                >
                    <b-table-column
                        v-for="(f, i) in fields"
                        :key="i"
                        :field="f.key"
                        :label="f.key != 'excluir' ? $t(f.label ? f.label : f.key) : ''"
                        :width="f.width"
                        :class="{
                            'excluir-field': f.key == 'excluir',
                        }"
                        :sortable="f.sortable"
                        :custom-sort="f.sortFn"
                        v-slot="props"
                    >
                        <div v-if="f.key == 'excluir'">
                            <b-button
                                v-if="permissao.update && !integracao"
                                class="action-button"
                                :type="props.row['situacao'] == 1 ? 'is-danger' : 'is-success'"
                                :icon-right="props.row['situacao'] == 1 ? 'delete' : 'check'"
                                @click="promptChangeSituacao(props.row)"
                                v-tippy
                                :title="$t(props.row['situacao'] == 1 ? 'desativar' : 'reativar')"
                            />
                        </div>
                        <div v-else-if="f.key == 'tabpreco'">
                            <span
                                class="tag is-info status-tag"
                                :style="props.row.cor ? `background-color: ${props.row.cor}` : ''"
                            >
                                {{ props.row[f.key] }}
                            </span>
                        </div>
                        <div v-else-if="f.key == 'situacao'">
                            <b-tag
                                class="table-tag table-tag-full-width"
                                :type="props.row['situacao'] == 1 ? 'is-success' : 'is-danger'"
                                size="is-medium"
                            >
                                {{ $t(props.row['situacao'] == 1 ? 'ativo' : 'inativo') }}
                            </b-tag>
                        </div>
                        <div v-else-if="f.key == 'produto'">
                            <a
                                @click="selectedPacoteEdit(props.row)"
                                v-if="permissao.update && !integracao"
                            >
                                {{ props.row[f.key] }}
                            </a>
                        </div>
                        <div v-else>
                            {{ props.row[f.key] }}
                        </div>
                    </b-table-column>
                </b-table>
                <PaginationViewer
                    class="mb-0"
                    :resetPagination="pagination.resetPagination"
                    :totalItems="pagination.totalRows"
                    :perPageOptions="pagination.perPageOptions"
                    :optionStarted="pagination.optionStarted"
                    @change="updatePagination"
                />
            </div>

            <!-- MODAL DE ASSOCIACAO -->
            <b-modal :active.sync="showModalAssociacao">
                <div>
                    <ProdutoModal
                        :idProduto="$route.params.id"
                        :selected="assPacoteProdutoSelected"
                        @fecharModal="fecharModal"
                    />
                </div>
            </b-modal>
        </div>
    </div>
</template>

<script>
// SERVICES
import AssProdutoPacoteKit from '@/services/vendas/produto/AssProdutoPacoteKitService';
import ProdutoModal from '@/components/vendas/pacote-kit/modal/ProdutoModal';

// COMPONENTS
import ContainerLoader from '@/components/content/loader/ContainerLoader';

export default {
    components: {
        ContainerLoader,
        ProdutoModal,
    },
    data() {
        return {
            ProdutoIntegracao: this.$store.state.user.tabelasERPWebServer.includes('PACOTE'),
            integracao: this.$store.state.user.tabelasERPWebServer.includes('PACOTEPRODUTO'),
            assprodutoProduto: [],
            fields: [
                { key: 'produto', label: 'produto', width: null, sortable: true, sortFn: null },
                { key: 'tabpreco', label: 'tabela-precos', sortable: true, sortFn: null },
                { key: 'unidademedida', label: 'unidades-medida', sortable: true, sortFn: null },
                { key: 'valorunitario', label: 'valor-unitario', sortable: true, sortFn: null },
                { key: 'qtde', label: 'qtde', sortable: true, sortFn: null },
                { key: 'valorcusto', label: 'valor-custo', sortable: true, sortFn: null },
                { key: 'situacao', sortable: true, sortFn: null },
                { key: 'excluir', sortable: false, sortFn: null },
            ],

            service: new AssProdutoPacoteKit(this.$http, this.$router),
            permissao: false,
            permissaoPacote: false,
            pagination: {
                resetPagination: false,
                perPageOptions: [10, 25, 50, 100],
                optionStarted: 0,
                perPage: null,
                totalRows: 0,
                currentPage: 1,
            },
            isLoading: false,
            assPacoteProdutoSelected: null,
            isEmpty: false,
            debouncedOnSearch: null,
            queryFilter: '',
            column: 'produto',
            order: 'asc',
            isSaving: false,
            delete: null,
            showModalAssociacao: false,
            situacaoSelected: { id: 4, label: 'todos' },
            situacaoSelect: [
                { id: 4, label: 'todos' },
                { id: 3, label: 'ativos' },
                { id: 2, label: 'inativos' },
            ],
        };
    },
    created() {
        this.pagination.perPage = this.pagination.perPageOptions[this.pagination.optionStarted];

        this.permissao = this.hasPermissionAccess(
            'vendas',
            'produtos',
            'ven-produto-politica-comercial-produto'
        );

        this.permissaoPacote = this.hasPermissionAccess('vendas', 'produtos', 'ven-produto');
        this.carregarDados();
        this.debouncedOnSearch = this.debounce(this.onSearch, 500);
    },
    methods: {
        carregarDados(currentPage = 1) {
            if (currentPage == 1 && this.pagination.currentPage != 1)
                this.pagination.resetPagination = true;

            this.isLoading = true;
            this.service
                .findAllByIdPacote(
                    this.$route.params.id,
                    this.situacaoSelected.id,
                    this.column,
                    this.order,
                    currentPage - 1,
                    this.pagination.perPage,
                    this.queryFilter
                )
                .then(this.mapItems)
                .then((value) => {
                    this.assprodutoProduto = value;
                    this.isEmpty = this.assprodutoProduto.length <= 0;
                })
                .catch((e) => {
                    this.isEmpty = true;
                    this.$root.showMessage('error', 'msg-erro-load');
                    console.error('Erro ao carregar os usuários!');
                })
                .finally((_) => {
                    this.isLoading = false;
                    this.pagination.resetPagination = false;
                });
        },
        mapItems(body) {
            this.pagination.totalRows = body.totalElements;

            return body.content.map((m) => {
                return {
                    idpacoteproduto: m.idpacoteproduto,
                    idtabpreco: m.idtabpreco,
                    idpacote: m.idpacote,
                    idunidademedida: m.idunidademedida,
                    valorunitario: m.valorunitario,
                    qtde: m.qtde,
                    valorcusto: m.valorcusto,
                    tabpreco: m.tabPreco.descricao,
                    produto: m.produto.descricao,
                    unidademedida: m.unidademedida.descricao,
                    situacao: m.situacao,
                    cor: m.tabPreco.cor,
                };
            });
        },
        updatePagination(value) {
            this.pagination.resetPagination = false;
            this.pagination.perPage = value.perPage;
            this.pagination.currentPage = value.currentPage;
            this.carregarDados(value.currentPage);
        },
        sortTable(field, order) {
            this.column = field;
            this.order = order;
            this.carregarDados(this.pagination.currentPage);
        },
        onSituacaoChanged(val) {
            this.situacaoSelected = val
                ? this.situacaoSelect.filter((v) => v.id == val.id)[0]
                : this.situacaoSelect[0];
            this.carregarDados();
        },
        onSearch(value) {
            this.queryFilter = this.removeAcentos(value);
            this.pagination.currentPage = 1;
            this.carregarDados();
        },
        selectedPacoteEdit(selected) {
            this.assPacoteProdutoSelected = selected;
            this.showModalAssociacao = true;
        },
        promptChangeSituacao(row) {
            this.delete = row;
            let message = this.$t(
                    row.situacao == 1
                        ? 'msg-confirmacao-desativacao-n'
                        : 'msg-confirmacao-reativacao-n', 
                    { n: row['produto'] }
                );
            this.$root.confirm({
                message: message,
                onConfirm: this.updateSituacaoRegistro,
                onCancel: this.removePrompt,
            });
        },
        removePrompt() {
            this.delete = null;
        },
        updateSituacaoRegistro() {
            let tempFailure = this.$t(
                    this.delete.situacao == 1 
                        ? 'msg-erro-ao-reativar-n' 
                        : 'msg-erro-ao-desativar-n', 
                    { n: this.$t('produto') }
                );
            let tempAssPacoteProduto = {
                idpacoteproduto: this.delete.idpacoteproduto,
                situacao: this.delete.situacao == 1 ? 0 : 1,
            };

            this.isLoading = true;
            this.service
                .updateSituacao(tempAssPacoteProduto)
                .then((r) => {
                    if (r.status == 200) {
                        let tempSuccess = this.$t(
                                r.content.situacao == 1
                                    ? 'msg-sucesso-ao-reativar-n'
                                    : 'msg-sucesso-ao-desativar-n', 
                                { n: this.$t('produto') }
                            );
                        this.$root.showMessage('success', tempSuccess, true, false);
                        this.carregarDados(this.pagination.currentPage);
                    } else if (r.status == 500) {
                        this.$root.showMessage('error', 'Erro ao atualizar status.');
                    }
                })
                .catch((e) => {
                    console.error('Erro ao atualizar status.', e);
                    this.$root.showMessage('error', tempFailure, true, false);
                })
                .finally((_) => {
                    this.isLoading = false;
                    this.delete = null;
                });
        },
        showModalVincularProduto() {
            this.assPacoteProdutoSelected = null;
            this.showModalAssociacao = !this.showModalAssociacao;
        },
        fecharModal() {
            this.assPacoteProdutoSelected = null;
            this.showModalAssociacao = false;
            this.carregarDados();
        },
    },
};
</script>

<style lang="scss" scoped>
.aba-produto {
    height: 100%;

    .botao-acao {
        margin-top: 24px;
        width: 100%;
        height: 40px;
    }

    @media (max-width: 760px) {
        .search-bar {
            padding-bottom: 0.4rem;
        }
        .botao-acao {
            margin-top: 0;
        }
    }
}
</style>
